<div class="stepper-container">
  <mat-horizontal-stepper #stepper="matHorizontalStepper" [linear]="true" class="stepper-content">
    <mat-step [stepControl]="firstFormGroup" [editable]="isEditable">
      <form [formGroup]="firstFormGroup">
        <ng-template matStepLabel>Optie</ng-template>
        <p>Druk op de knop die het beste bij u past</p>
        <div class="center-button">
          <app-custom-btn mat-raised-button customClass="large" (click)="selectOption('company')">Bedrijf</app-custom-btn>
          <app-custom-btn mat-raised-button customClass="large" (click)="selectOption('school')">School</app-custom-btn>
          <app-custom-btn mat-raised-button customClass="large" (click)="selectOption('other')">Individu</app-custom-btn>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" [editable]="false">
      <form [formGroup]="secondFormGroup" fxLayout="column" fxLayoutGap="16px">
        <ng-template matStepLabel>Details</ng-template>
        <mat-form-field>
          <input matInput placeholder="Vul uw naam in" formControlName="visitorName" required>
          <mat-label>Naam</mat-label>
        </mat-form-field>
        <ng-container *ngIf="selectedOption">
          <mat-form-field *ngIf="selectedOption === 'school'">
            <mat-label>School naam</mat-label>
            <input type="text" matInput placeholder="Vul uw volledige school naam in aub" formControlName="visitorSchool" required [matAutocomplete]="auto"/>
          </mat-form-field>
          <mat-form-field *ngIf="selectedOption === 'other'">
            <input matInput placeholder="Reden van bezoek" formControlName="visitorOther" required>
            <mat-label>Geef aan wat de reden van uw bezoek is</mat-label>
          </mat-form-field>
          <mat-form-field *ngIf="selectedOption === 'company'">
            <mat-label>Van welk bedrijf bent u?</mat-label>
            <input type="text" matInput placeholder="Vul uw volledige bedrijfsnaam in aub" formControlName="visitorCompany" required [matAutocomplete]="auto"/>
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">{{ option }}</mat-option>
          </mat-autocomplete>
        </ng-container>
        <mat-form-field>
          <mat-label>Met wie heeft u een afspraak?</mat-label>
          <input type="text" matInput placeholder="Vul de naam in van de persoon met wie u een afspraak heeft" formControlName="visitorMeeting" required />
        </mat-form-field>
      </form>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup">
      <ng-template matStepLabel></ng-template>
      <div class="center" fxLayout="column" fxLayoutGap="16px">
        <h1>Welkom bij DLA ICT {{ secondFormGroup.value.visitorName }}!</h1>
        <p>U bent geregistreerd en kan dit scherm nu sluiten.</p>
        <p>Dit scherm sluit automatisch in {{ countdown }} seconden.</p>
        <app-custom-btn (click)="goBack(0)" customClass="back larger">
          <mat-icon>keyboard_arrow_left</mat-icon>
          nu sluiten
        </app-custom-btn>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

  <div class="nav-buttons">
    <div *ngIf="stepper.selectedIndex === 0 || stepper.selectedIndex === 1" class="bottom">
      <app-custom-btn (click)="goBack(stepper.selectedIndex)" customClass="back">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </app-custom-btn>
    </div>
    <div *ngIf="stepper.selectedIndex === 1" class="bottom">
      <app-custom-btn
        [disabled]="secondFormGroup.invalid || submitting || !secondFormGroup.value['visitor' + selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)]"
        (click)="onSubmit()">
        Bevestigen
      </app-custom-btn>
    </div>
  </div>
</div>
